import React, { useState, useMemo, useContext, useEffect } from "react";
import _ from "lodash";
import useApi from "api/useApi";
import styled from "styled-components";
import UploadAuthorization from "./UploadAuthorization";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import UserService from "services/UserService";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import { getAPIAuthorizationList } from "services/ConfigServices";
import axios from "axios";
import { NotificationContainer, NotificationManager } from 'react-notifications';
import 'assets/css/customNotifications.css';
import { statusEnergy, typeAuthorization, authorizationStatus } from "variables/lists/authorization";
import moment from "moment";

export default function useEntitesTable(props) {
  const permis = JSON.parse(localStorage.getItem('permission')) || [];
  const realestateupdate = permis.includes("realestate_update");
  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup } = appContext;
  const [results, setResults] = useState({});
  const [gridState, setGridState] = useState();
  const [refresh, setRefresh] = useState(false);
  const [permissionList, setPermissionList] = useState([]);
  const [viewList, setViewList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [totalRows, setTotalRows] = useState(0);

  let prevIdGroup = ["0"];
  let prevRefresh = true;
  useEffect(() => {
    if (chartIdGroup && chartIdGroup[0] !== "0") {
      if ((prevIdGroup && prevIdGroup === chartIdGroup)
        && (prevRefresh && prevRefresh === refresh)) {
        return;
      }
      setLoading(true);
      async function fetchData() {
        const response = await axios.get(
          getAPIAuthorizationList(chartIdGroup),
          {
            headers: {
              Authorization: `Bearer ${UserService.getToken()}`,
            },
          }
        );
        setResults(response.data);
        setLoading(false);
      }
      prevRefresh = refresh;
      prevIdGroup = chartIdGroup;
      fetchData();
    }
  }, [chartIdGroup, refresh]);

  // ----------------------------------------------------------

  const [filterText, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);

  const StyledTextField = styled.input`
    height: 32px;
    width: 200px;
    border: 0px;
    padding: 0 32px 0 16px;
    &:hover {
      cursor: text;
    }
  `;

  const ClearButton = styled.button`
    border: 0px solid rgba(0, 0, 0, 0.15);
    border-left: 0px;
    background-color: none;
    height: 34px;
    width: 32px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    &:hover {
      cursor: pointer;
    }
  `;

  const SearchContainer = styled.div`
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
  `;

  const UploadButton = styled.div`
    margin-left: 15px;
    &:hover {
      cursor: pointer;
    }
  `;

  const TableName = styled.h1`
    margin-right: auto;
    margin-left: -8px;
    font-size: 1.3rem;
    font-weight: 500;
  `;

  const refreshTable = () => {
    console.log("refresh table");
    setRefresh(!refresh);
  };

  const FilterComponent = ({ filterText, onFilter, onClear }) => (
    <>
      <div style={{ marginTop: "-7px" }}>
        <TextField
          type="search"
          variant="outlined"
          margin="normal"
          size="small"
          autoFocus="true"
          value={filterText}
          onChange={onFilter}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      </div>
    </>
  );

  const setNotification = (status, text) => {
    if (status === 'success') {
      NotificationManager.success(text);
    }
    else {
      NotificationManager.error(text);
    }
  };

  const UploadComponent = ({ onUpload }) => (
    <>
      <UploadButton type="button" onClick={onUpload}>
        {/*<PublishIcon fontSize="medium" />
        <UploadText>Import</UploadText>*/}
        <UploadAuthorization type="button" onClick={onUpload} refetch={refreshTable} setLoading={setLoading} setNotification={setNotification} />
      </UploadButton>
      <NotificationContainer />
    </>
  );

  const filteredItems = _.get(
    results,
    "authorizations",
    []
  ).filter(
    (item) =>
      (item.type && typeAuthorization.find((x) => x.id == item.type) && typeAuthorization.find((x) => x.id == item.type).name.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.energy && statusEnergy.find((x) => x.id == item.energy) && statusEnergy.find((x) => x.id == item.energy).name.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.dso && item.dso.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.legalname && item.legalname.toLowerCase().includes(filterText.toLowerCase())) || 
      (item.dateend && moment(item.dateend).isValid() && moment(item.dateend).format("YYYY-MM-DD").includes(filterText)) ||
      (authorizationStatus.find((x) => x.id == item.verified) && authorizationStatus.find((x) => x.id == item.verified).name.toLowerCase().includes(filterText.toLowerCase()))
  );

  const subHeaderComponentMemo = useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };

    const onFilterText = (e) => setFilterText(e.target.value);

    //setTimeout(() => document.getElementById(`search`).focus());

    return (
      <>
        <TableName></TableName>
        <FilterComponent
          key="FilterComponent"
          onFilter={onFilterText}
          onClear={handleClear}
          filterText={filterText}
        />
        {realestateupdate ?
          <UploadComponent key="UploadComponent" onUpload={handleClear} /> : <></>}
      </>
    );
  }, [filterText, resetPaginationToggle]);

  return {
    gridState: {
      defaultPageSize: 10,
      data: filteredItems,
      paginationTotalRows: totalRows,
      filterable: true,
      manual: true,
      paginationResetDefaultPage: resetPaginationToggle,
      subHeaderComponent: subHeaderComponentMemo,
      loading,
    },
    refreshTable,
    setLoading,
  };
}
